import moment from 'moment-timezone';

export default function getInactivationDateCalc(periodicity, day, month, staticInactiveDate = false) {
  const date = moment();

  switch (periodicity) {
    case 'YEAR':
      date.add(1, 'year');

      if (month != null && staticInactiveDate) {
        // Moment usa meses de 0 a 11
        date.month(month - 1);
      }

      if (day != null && staticInactiveDate) {
        // Evita días inválidos (ej. 31 de febrero)
        date.date(Math.min(day, date.daysInMonth()));
      }
      break;

    case 'MONTH':
      date.add(1, 'month');

      if (day != null && staticInactiveDate) {
        date.date(Math.min(day, date.daysInMonth()));
      }
      break;

    case 'TRIMESTER':
      date.add(3, 'months');

      if (day != null && staticInactiveDate) {
        date.date(Math.min(day, date.daysInMonth()));
      }
      break;

    default:
      throw new Error(`Periodicidad inválida: ${periodicity}`);
  }

  return date.toDate().toLocaleDateString('es-ES', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}